export default {
  complete: "Completado",
  confirmed: "Confirmado",
  pending: "Pendiente",
  accepted: "Aceptado",
  rejected: "Rechazado",
};
